
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-marker\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M12.327,7.124c0,1.292-1.047,2.339-2.339,2.339S7.648,8.417,7.648,7.124c0-1.292,1.047-2.339,2.339-2.339\r\n\tS12.327,5.832,12.327,7.124z M20,10c0,5.523-4.478,10-10,10S0,15.523,0,10S4.477,0,10,0S20,4.477,20,10z M15.201,7.573\r\n\tc0-2.781-2.286-5.106-5.106-5.106c-0.035,0-0.061-0.002-0.095-0.001c-0.028,0-0.064,0.002-0.094,0.002\r\n\tc-2.82,0-5.106,2.316-5.106,5.106c0,4.189,5.202,9.961,5.202,9.961S15.201,11.502,15.201,7.573z\"/> </symbol>";
module.exports = sprite.add(image, "icon-marker");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/marker.svg
 ** module id = 202
 ** module chunks = 24
 **/